/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* A column in a log schema.
*/
export class LogsSchemaColumn {
  /**
  * The name of the column.
  */
  'name'?: string;
  /**
  * The data type of the column.
  */
  'type'?: string;
  /**
  * Sample values for the column (optional).
  */
  'values'?: Array<string>;
  /**
  * Whether this column contains private data.
  */
  '_private'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "type",
      "baseName": "type",
      "type": "string",
      "format": ""
    },
    {
      "name": "values",
      "baseName": "values",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "_private",
      "baseName": "private",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return LogsSchemaColumn.attributeTypeMap;
  }

  public constructor() {
  }
}

